import React from 'react';
import { FieldError } from 'react-hook-form';
import {
	PrescriptionMedicament,
	useLazyPrescriptionMedicamentQuery,
} from '../../../graphql/graphql';
import DynamicSelect from '../../../Components/Base/DynamicSelect/DynamicSelect';
import { SelectValue } from '../../../Components/Base/Select/Select';
import PrescriptionMedicamentSelectItem from './PrescriptionMedicamentSelectItem';

export interface PrescriptionMedicamentsSelectValue extends SelectValue {
	item: PrescriptionMedicament;
}

interface Props {
	onChange?: (value: PrescriptionMedicamentsSelectValue) => void;
	workplaceId?: string;
	value?: {
		id: string;
		label: string;
	};
	error?: FieldError;
}

const PrescriptionMedicamentsSelect: React.FC<Props> = ({
	value,
	onChange,
}) => {
	const [searchMedicaments] = useLazyPrescriptionMedicamentQuery();

	const handleSearchItem = async (
		searchInput: string,
	): Promise<PrescriptionMedicamentsSelectValue[]> => {
		const { prescriptionMedicaments } = await searchMedicaments({
			search: searchInput,
		}).unwrap();

		const items: PrescriptionMedicamentsSelectValue[] = [];

		for (const prescriptionMedicament of prescriptionMedicaments?.data || []) {
			if (prescriptionMedicament && prescriptionMedicament.id) {
				items.push({
					value: prescriptionMedicament.id,
					label: '',
					item: prescriptionMedicament as PrescriptionMedicament,
				});
			}
		}

		return items;
	};

	return (
		<DynamicSelect
			searchItems={handleSearchItem}
			value={value ? { value: value.id, label: value.label } : undefined}
			onChange={onChange}
			ItemTemplate={PrescriptionMedicamentSelectItem}
		/>
	);
};

export default PrescriptionMedicamentsSelect;
